/*
 * Design & Hyde — storefront behaviour.
 * Ports the interactions of the design source (ui_kits/website/*.jsx) to plain JS:
 * announcement rotation, mega menu, mobile nav, AJAX cart drawer, quick add, product page
 * (leg-style-gated options, live variant preview, shade/size/finish-driven photography),
 * collection type filter, gallery room filter, trade form, shop-by-shade.
 */
(function () {
  if (window.DHStore) return;
  var DH = (window.DHStore = {});

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  /* Horizon scrolls .page-wrapper (not the window) on desktop */
  function scroller() { var w = document.querySelector('.page-wrapper'); return w && w.scrollHeight > w.clientHeight && getComputedStyle(w).overflowY !== 'visible' ? w : window; }
  function toTop() { scroller().scrollTo({ top: 0, behavior: 'smooth' }); }
  function lock(on) { if (on) document.documentElement.setAttribute('scroll-lock', ''); else document.documentElement.removeAttribute('scroll-lock'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* Asset URLs come from Liquid's asset_url; Shopify serves resized copies at name_WIDTHx.ext */
  function sized(url, w) {
    if (!url) return url;
    if (url.indexOf('/assets/') > -1) return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');
    var base = url.replace(/([?&])width=\d+/, '$1').replace(/\?&/, '?').replace(/&&/, '&').replace(/[?&]$/, '');
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  DH.formatMoney = function (cents, format) {
    format = format || DH.moneyFormat || '£{{amount}}';
    var n = (Number(cents) / 100);
    function fmt(num, dec, th, dp) { var p = num.toFixed(dec).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? dp + p[1] : ''); }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(n, 0, '.', ',');
      return fmt(n, 2, ',', '.');
    });
  };

  /* ------------------------------------------------------------ Announcement */
  function initAnnounce() {
    var bar = $('[data-dh-announce]');
    if (!bar) return;
    var msgs = $$('.dh-announce__msg', bar);
    if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 5200);
  }

  /* ------------------------------------------------------------ Header, mega menu, mobile nav */
  function initHeader() {
    var header = $('[data-dh-header]');
    if (!header) return;
    var bar = $('[data-dh-bar]', header);
    var setH = function () { document.documentElement.style.setProperty('--dh-header-h', header.offsetHeight + 'px'); };
    setH();
    window.addEventListener('resize', setH);

    var open = null;
    function show(id) {
      $$('[data-dh-mega-panel]', header).forEach(function (p) { p.hidden = p.id !== id; });
      $$('[data-dh-mega]', header).forEach(function (a) { a.setAttribute('aria-expanded', a.getAttribute('data-dh-mega') === id ? 'true' : 'false'); });
      bar.classList.toggle('is-open', !!id);
      open = id;
    }
    $$('[data-dh-mega]', header).forEach(function (a) {
      a.addEventListener('mouseenter', function () { show(a.getAttribute('data-dh-mega')); });
      a.addEventListener('focus', function () { show(a.getAttribute('data-dh-mega')); });
    });
    $$('[data-dh-mega-close], .dh-logo', header).forEach(function (a) {
      a.addEventListener('mouseenter', function () { show(null); });
      a.addEventListener('focus', function () { show(null); });
    });
    bar.addEventListener('mouseleave', function () { show(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (open) show(null); closeMnav(); DH.closeCart(); } });
    document.addEventListener('focusin', function (e) { if (open && !bar.contains(e.target)) show(null); });

    var mnav = $('[data-dh-mnav]', header);
    var opener = $('[data-dh-mnav-open]', header);
    function closeMnav() {
      if (!mnav || !mnav.classList.contains('is-open')) return;
      mnav.classList.remove('is-open'); mnav.setAttribute('aria-hidden', 'true');
      opener.setAttribute('aria-expanded', 'false'); lock(false);
      opener.focus();
    }
    if (opener) opener.addEventListener('click', function () {
      mnav.classList.add('is-open'); mnav.setAttribute('aria-hidden', 'false');
      opener.setAttribute('aria-expanded', 'true'); lock(true);
      var c = $('[data-dh-mnav-close]', mnav.querySelector('.dh-mnav__panel')); if (c) c.focus();
    });
    $$('[data-dh-mnav-close]', header).forEach(function (b) { b.addEventListener('click', closeMnav); });
  }

  /* ------------------------------------------------------------ Cart drawer */
  var cartEl, lastFocus;
  function sectionId() { var h = $('[data-dh-header]'); return h && h.getAttribute('data-section-id'); }
  DH.openCart = function () {
    cartEl = cartEl || $('[data-dh-cart]');
    if (!cartEl) { window.location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    cartEl.classList.add('is-open'); cartEl.setAttribute('aria-hidden', 'false');
    lock(true);
    var c = $('.dh-cart__head [data-dh-cart-close]', cartEl); if (c) c.focus();
  };
  DH.closeCart = function () {
    cartEl = cartEl || $('[data-dh-cart]');
    if (!cartEl || !cartEl.classList.contains('is-open')) return;
    cartEl.classList.remove('is-open'); cartEl.setAttribute('aria-hidden', 'true');
    lock(false);
    if (lastFocus) lastFocus.focus();
  };
  function renderSections(sections) {
    var id = sectionId();
    if (!sections || !id || !sections[id]) return;
    var doc = new DOMParser().parseFromString(sections[id], 'text/html');
    var fresh = $('[data-dh-cart-panel]', doc);
    var panel = $('[data-dh-cart-panel]');
    if (fresh && panel) panel.innerHTML = fresh.innerHTML;
    var count = $('[data-dh-cart-count]', doc), badge = $('[data-dh-cart-count]');
    if (count && badge) { badge.textContent = count.textContent; badge.hidden = count.hasAttribute('hidden'); }
  }
  DH.addToCart = function (items) {
    var body = { items: items };
    var id = sectionId(); if (id) body.sections = id;
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { renderSections(j.sections); DH.openCart(); return j; });
  };
  function changeLine(line, qty) {
    cartEl = cartEl || $('[data-dh-cart]');
    if (cartEl) cartEl.classList.add('is-busy');
    var body = { line: Number(line), quantity: Math.max(0, Number(qty) || 0) };
    var id = sectionId(); if (id) body.sections = id;
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function (j) { renderSections(j.sections); })
      .finally(function () { if (cartEl) cartEl.classList.remove('is-busy'); });
  }
  function initCart() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-dh-cart-open]');
      if (t && $('[data-dh-cart]') && !document.body.classList.contains('template-cart')) { e.preventDefault(); DH.openCart(); return; }
      if (e.target.closest('[data-dh-cart-close]')) { DH.closeCart(); return; }
      var q = e.target.closest('[data-dh-cart] [data-dh-qty]');
      if (q) { changeLine(q.getAttribute('data-dh-qty'), q.getAttribute('data-q')); return; }
      var quick = e.target.closest('[data-dh-quick]');
      if (quick) {
        var props = {};
        (quick.getAttribute('data-dh-props') || '').split('|').forEach(function (p) {
          var i = p.indexOf(':'); if (i > 0) props[p.slice(0, i)] = p.slice(i + 1);
        });
        quick.disabled = true;
        DH.addToCart([{ id: Number(quick.getAttribute('data-dh-quick')), quantity: 1, properties: props }])
          .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart.'); })
          .finally(function () { quick.disabled = false; });
      }
    });
    document.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-dh-cart] [data-dh-qty-input]');
      if (inp) changeLine(inp.getAttribute('data-dh-qty-input'), inp.value);
    });
  }

  /* ------------------------------------------------------------ Shared markup helpers */
  function sectionHead(eyebrow, title, link) {
    return '<div class="dh-head"><div class="dh-head__text"><p class="dh-eyebrow dh-eyebrow--rule">' + esc(eyebrow) + '</p><h2 class="dh-d3">' + esc(title) + '</h2></div>' +
      (link ? '<a class="dh-textlink" href="' + esc(link.url) + '"' + (link.attr || '') + '>' + esc(link.label) + '</a>' : '') + '</div>';
  }
  function img(url, alt, w, cls, style) {
    return '<img src="' + esc(sized(url, w || 700)) + '" srcset="' + esc(sized(url, 400)) + ' 400w, ' + esc(sized(url, 700)) + ' 700w, ' + esc(sized(url, 1000)) + ' 1000w" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(alt) + '" loading="lazy"' + (cls ? ' class="' + cls + '"' : '') + (style ? ' style="' + style + '"' : '') + '>';
  }

  /* ------------------------------------------------------------ Product page */
  /* One template for every product. Reads the Shopify product (options, variants, media),
     the [tags] in each photograph's alt text and the dh.* metafields. */
  var NUM_WORDS = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen', 'Twenty', 'Twenty-one', 'Twenty-two', 'Twenty-three', 'Twenty-four'];
  function handleize(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function parseTags(alt) {
    var tags = [], re = /\[([^\]]+)\]/g, m;
    while ((m = re.exec(alt || ''))) {
      var parts = m[1].split(';').map(function (x) { return x.trim(); });
      var head = parts[0], i = head.indexOf(':');
      var t = { key: (i > -1 ? head.slice(0, i) : head).trim().toLowerCase(), value: i > -1 ? head.slice(i + 1).trim() : '' };
      parts.slice(1).forEach(function (p) {
        var sp = p.indexOf(' ');
        var k = sp > -1 ? p.slice(0, sp) : p, v = sp > -1 ? p.slice(sp + 1).trim() : '';
        if (k === 'contain' || k === 'cover') t.fit = k; else t[k] = v;
      });
      tags.push(t);
    }
    return tags;
  }
  /* "Sand Oak*, Walnut" / '12" = 30cm, 15" = 38cm*' / one entry per line */
  function listItems(str) {
    return String(str || '').split(/[\n,]/).map(function (x) { return x.trim(); }).filter(Boolean).map(function (x) {
      var def = /\*\s*$/.test(x) || /\*\s*=/.test(x); x = x.replace(/\*/g, '');
      var eq = x.indexOf('=');
      return { name: (eq > -1 ? x.slice(0, eq) : x).trim(), detail: eq > -1 ? x.slice(eq + 1).trim() : '', def: def };
    });
  }
  function defaultOf(items) { var d = items.filter(function (i) { return i.def; })[0] || items[0]; return d ? d.name : null; }
  function roleOf(name) {
    var n = String(name || '').toLowerCase();
    if (['length', 'size', 'throw size', 'bed size'].indexOf(n) > -1) return 'size';
    if (['frame', 'finish', 'leg finish', 'frame finish', 'wood finish'].indexOf(n) > -1) return 'finish';
    if (n === 'buy as') return 'buy';
    if (['fur shade', 'shade', 'colour', 'color', 'fur colour'].indexOf(n) > -1) return 'shade';
    return 'other';
  }

  function initProduct(root) {
    var dataEl = $('[data-dh-product-json]', root);
    if (!dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var P = D.product, MF = D.mf || {}, M = D.mats, T = D.text || {};
    DH.moneyFormat = D.moneyFormat;
    var money = function (c) { return DH.formatMoney(c, D.moneyFormat); };
    var params = new URLSearchParams(window.location.search);
    var type = P.type || '';

    /* Photographs and their tags */
    var media = (D.media || []).map(function (m) { return { src: m.src, desc: m.desc || '', tags: parseTags(m.alt) }; });
    function tagged(key, value) {
      return media.filter(function (m) { return m.tags.some(function (t) { return t.key === key && (value == null || t.value.toLowerCase() === String(value).toLowerCase()); }); });
    }
    function tagOf(m, key) { return m.tags.filter(function (t) { return t.key === key; })[0]; }
    var mainShots = media.filter(function (m) { return !m.tags.length || tagOf(m, 'main'); });
    if (!mainShots.length) mainShots = media;
    function tile(key, value) { var l = tagged(key, value); return l.filter(function (m) { return (tagOf(m, key) || {}).tile !== undefined; })[0] || l[0] || null; }

    /* Options: each Shopify option gets a role from its name */
    var optNames = (P.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var furLib = M.fur.map(function (f) { return f.name; });
    var roles = optNames.map(function (n, i) {
      var r = roleOf(n);
      if (r === 'shade' && !/shade/i.test(n)) {
        var vals = P.variants.map(function (v) { return v.options[i]; });
        if (!vals.every(function (v) { return furLib.indexOf(v) > -1; })) r = 'other';
      }
      return r;
    });
    var idx = function (role) { return roles.indexOf(role); };
    var values = optNames.map(function (_, i) {
      var seen = []; P.variants.forEach(function (v) { if (seen.indexOf(v.options[i]) < 0) seen.push(v.options[i]); }); return seen;
    });
    var hasOnlyDefault = P.variants.length === 1 && values[0] && values[0][0] === 'Default Title';

    /* Material lists from metafields */
    var furNames = MF.shades === 'all' ? M.fur.map(function (f) { return f.name; }) : listItems(MF.shades).map(function (i) { return i.name; });
    var finishItems = listItems(MF.finishes);
    var heightItems = listItems(MF.heights);
    var sizeDims = {}; listItems(MF.sizeDimensions).forEach(function (i) { sizeDims[i.name] = i.detail; });
    var swatchCount = Number(MF.swatchCount) || 0;
    function furOf(name) { return M.fur.filter(function (f) { return f.name === name; })[0] || { name: name, image: M.filesBase + 'fur-' + handleize(name) + '.jpg', color: '#d6c8b4' }; }
    function woodOf(name) { return M.wood.filter(function (f) { return f.name === name; })[0] || { name: name, image: M.filesBase + 'wood-' + handleize(name) + '.jpg', color: '#d6c8b4' }; }
    if (idx('finish') > -1 && !finishItems.length) finishItems = values[idx('finish')].map(function (v) { return { name: v }; });

    var shadeIsOption = idx('shade') > -1, finishIsOption = idx('finish') > -1;
    var hasShadePicker = !swatchCount && (shadeIsOption || furNames.length > 0);
    var hasFinish = finishIsOption || finishItems.length > 0;
    var frameNoun = /frame/i.test((MF.finishLabel || '') + ' ' + (finishIsOption ? optNames[idx('finish')] : '')) ? 'frame' : 'legs';

    /* State */
    var start = P.variants.filter(function (v) { return v.id === D.variantId; })[0] || P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
    var st = { opts: start.options.slice(), shade: null, finish: null, height: defaultOf(heightItems), swatches: [], lastPick: null, active: 0 };
    if (!shadeIsOption && furNames.length && !swatchCount) st.shade = MF.defaultShade || furNames[0];
    if (!finishIsOption && finishItems.length) st.finish = defaultOf(finishItems);
    function setRole(role, val) {
      var i = idx(role);
      if (i > -1) { if (values[i].indexOf(val) > -1) { st.opts[i] = val; return true; } return false; }
      if (role === 'shade' && furNames.indexOf(val) > -1) { st.shade = val; return true; }
      if (role === 'finish' && finishItems.some(function (f) { return f.name === val; })) { st.finish = val; return true; }
      return false;
    }
    if (params.get('shade')) setRole('shade', params.get('shade'));
    if (params.get('finish') && setRole('finish', params.get('finish'))) st.lastPick = 'finish';
    if (params.get('size') && setRole('size', params.get('size'))) st.lastPick = 'size';
    if (params.get('buy')) setRole('buy', params.get('buy'));
    var get = function (role) { var i = idx(role); return i > -1 ? st.opts[i] : role === 'shade' ? st.shade : role === 'finish' ? st.finish : null; };

    function findVariant(over) {
      var want = st.opts.slice();
      for (var k in (over || {})) { var i = idx(k); if (i > -1) want[i] = over[k]; else if (!isNaN(k)) want[+k] = over[k]; }
      return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === want[i]; }); })[0] || null;
    }

    /* Gallery: the photographs follow the customer's last choice — finish, then size, then shade */
    function gallery() {
      var leg = st.lastPick === 'finish' ? tagged('finish', get('finish')) : [];
      var len = st.lastPick === 'size' ? tagged('size', get('size')) : [];
      var shade = get('shade') ? tagged('shade', get('shade')).filter(function (m) { return !('tile' in tagOf(m, 'shade')); }) : [];
      var g = leg.length ? leg : len.length ? len : shade.length ? shade : mainShots;
      return g.map(function (m) { return m.src; });
    }
    function sizeOfShot(src) {
      if (idx('size') < 0) return null;
      var m = media.filter(function (x) { return x.src === src; })[0]; if (!m) return null;
      var t = tagOf(m, 'size') || tagOf(m, 'length') || tagOf(m, 'shows');
      return t && values[idx('size')].indexOf(t.value) > -1 ? t.value : null;
    }
    var thumbs = $('[data-dh-thumbs]', root), hero = $('.dh-gallery__hero', root);
    if (hero && hero.tagName === 'IMG') hero.addEventListener('load', function () {
      var w = hero.naturalWidth, h = hero.naturalHeight; if (!w || !h) return;
      hero.style.aspectRatio = String(w / h > 1.05 ? Math.min(w / h, 2) : 0.8);
    });
    var lastGallery = null;
    function renderGallery() {
      var g = gallery();
      if (!g.length || !hero || hero.tagName !== 'IMG') return;
      var key = g.join('|');
      if (key !== lastGallery) { st.active = 0; lastGallery = key; }
      thumbs.innerHTML = g.map(function (src, i) {
        return '<button type="button" data-i="' + i + '" aria-label="Show image ' + (i + 1) + '" aria-current="' + (i === st.active) + '"><img src="' + esc(sized(src, 200)) + '" alt="" loading="lazy"></button>';
      }).join('');
      var src = g[st.active] || g[0];
      if (hero.getAttribute('data-src') !== src) {
        hero.style.aspectRatio = '';
        hero.setAttribute('data-src', src);
        hero.removeAttribute('srcset');
        hero.src = sized(src, 1000);
        hero.srcset = sized(src, 700) + ' 700w, ' + sized(src, 1000) + ' 1000w, ' + sized(src, 1600) + ' 1600w';
        var shot = media.filter(function (x) { return x.src === src; })[0];
        hero.alt = (shot && shot.desc) || P.title;
      }
      var shown = sizeOfShot(src);
      if (shown && shown !== get('size') && findVariant({ size: shown })) { st.opts[idx('size')] = shown; renderControls(); }
    }
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-i]'); if (!b) return;
      st.active = Number(b.getAttribute('data-i')); renderGallery();
    });

    /* Live variant preview: the chosen fur and grain, as photographs */
    var preview = $('[data-dh-preview]', root);
    function renderPreview() {
      if (!preview) return;
      var s = get('shade'), f = hasFinish ? get('finish') : null;
      if (!s && !f) { preview.hidden = true; return; }
      var fur = s && furOf(s), wood = f && woodOf(f);
      preview.hidden = false;
      preview.innerHTML =
        (fur ? '<span class="dh-preview__fur" style="background-color:' + fur.color + ';background-image:url(' + esc(sized(fur.image, 100)) + ')"></span>' : '') +
        (wood ? '<span class="dh-preview__wood" style="background-color:' + wood.color + (wood.image ? ';background-image:url(' + esc(sized(wood.image, 100)) + ')' : '') + '"></span>' : '') +
        '<span class="dh-preview__text">' + (fur ? '<span>' + esc(s) + ' fur</span>' : '') + (wood ? '<span>' + esc(f) + ' ' + frameNoun + '</span>' : '') + '</span>';
    }

    /* Buy column */
    var priceEl = $('[data-dh-price]', root), compareEl = $('[data-dh-compare]', root), noteEl = $('[data-dh-price-note]', root);
    var optsEl = $('[data-dh-options]', root), addBtn = $('[data-dh-add]', root), errEl = $('[data-dh-error]', root);
    var swatchFirstDot = $('[data-dh-swatchfirst-dot]', root);
    function label(text, value) { return '<p class="dh-picker__label"><span>' + esc(text) + '</span>' + (value ? '<span class="dh-picker__value">' + esc(value) + '</span>' : '') + '</p>'; }
    function sizeButtons(i, dims) {
      return '<div class="dh-sizes">' + values[i].map(function (val) {
        var o = {}; o[i] = val; var v = findVariant(o);
        var meta = [dims && dims[val], v && dims ? money(v.price) : ''].filter(Boolean).join(' · ');
        return '<button type="button" class="dh-size" data-opt="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + (st.opts[i] === val) + '"' + (v ? '' : ' disabled') + '>' +
          '<span class="dh-size__name">' + esc(val) + '</span>' + (meta ? '<span class="dh-size__meta">' + esc(meta) + (v && !v.available ? ' · sold out' : '') + '</span>' : (v && !v.available ? '<span class="dh-size__meta">Sold out</span>' : '')) + '</button>';
      }).join('') + '</div>';
    }
    function furSwatches(selected, attr) {
      return '<div class="dh-swatches">' + furNames.map(function (n) {
        var f = furOf(n);
        return '<button type="button" class="dh-swatch" ' + attr + '="' + esc(n) + '" title="' + esc(n) + '" aria-label="' + esc(n) + '" aria-pressed="' + (n === selected) + '"><span style="background-color:' + f.color + ';background-image:url(' + esc(sized(f.image, 100)) + ')"></span></button>';
      }).join('') + '</div>';
    }
    function renderControls() {
      var v = findVariant();
      var html = '';
      var si = idx('size'), bi = idx('buy'), fi = idx('finish'), shi = idx('shade');
      var single = bi > -1 ? findVariant({ buy: values[bi][0] }) : null;
      var pair = bi > -1 && values[bi][1] ? findVariant({ buy: values[bi][1] }) : null;
      var saving = single && pair ? single.price * 2 - pair.price : 0;
      var pct = single && pair ? Math.round((1 - pair.price / (single.price * 2)) * 100) : 0;
      var isPair = bi > -1 && pair && st.opts[bi] === values[bi][1];

      if (v) priceEl.textContent = money(v.price);
      if (compareEl) { var cmp = v && v.compare_at_price > v.price; compareEl.hidden = !cmp; if (cmp) compareEl.textContent = money(v.compare_at_price); }
      noteEl.textContent = isPair ? values[bi][1] + ' · ' + pct + '% off · save ' + money(saving) : (si > -1 ? st.opts[si] : '');
      noteEl.className = 'dh-buy__note' + (isPair ? ' dh-buy__note--accent' : '');

      if (si > -1) html += '<div>' + label(optNames[si]) + sizeButtons(si, sizeDims) + '</div>';
      if (heightItems.length) html += '<div>' + label('Leg height') + '<div class="dh-sizes">' + heightItems.map(function (h) {
        return '<button type="button" class="dh-size" data-height="' + esc(h.name) + '" aria-pressed="' + (h.name === st.height) + '"><span class="dh-size__name">' + esc(h.name) + '</span>' + (h.detail ? '<span class="dh-size__meta">' + esc(h.detail) + '</span>' : '') + '</button>';
      }).join('') + '</div></div>';
      if (bi > -1) {
        if (single && pair && values[bi].length === 2) {
          var fin = get('finish');
          html += '<div><p class="dh-picker__label" style="color:var(--ink-900)">' + esc(optNames[bi]) + '</p><div class="dh-choices">' +
            '<button type="button" class="dh-choice" data-opt="' + bi + '" data-val="' + esc(values[bi][0]) + '" aria-pressed="' + !isPair + '"><span class="dh-choice__t">A ' + esc(values[bi][0].toLowerCase()) + ' ' + esc(type.toLowerCase()) + '</span><span class="dh-choice__n">' + money(single.price) + (fin ? ' · ' + esc(fin) + ' ' + frameNoun : '') + '</span></button>' +
            '<button type="button" class="dh-choice" data-opt="' + bi + '" data-val="' + esc(values[bi][1]) + '" aria-pressed="' + isPair + '"><span class="dh-choice__t">A ' + esc(values[bi][1].toLowerCase()) + (pct > 0 ? ' · ' + pct + '% off' : '') + '</span><span class="dh-choice__n">' + money(pair.price) + (saving > 0 ? ' · save ' + money(saving) : '') + '</span></button></div></div>';
        } else html += '<div>' + label(optNames[bi]) + sizeButtons(bi) + '</div>';
      }
      if (hasShadePicker) {
        var s = get('shade');
        if (shi > -1) { furNames = values[shi]; html += '<div>' + label(optNames[shi], s) + furSwatches(s, 'data-shade') + '</div>'; }
        else html += '<div>' + label('Fur shade', s) + furSwatches(s, 'data-shade') + '</div>';
      }
      if (swatchCount) {
        var full = st.swatches.length >= swatchCount;
        html += '<div><div class="dh-picker__label" style="justify-content:space-between;letter-spacing:.06em"><span style="color:var(--ink-900)">Choose ' + esc((NUM_WORDS[swatchCount] || swatchCount).toString().toLowerCase()) + ' fur shades</span><span style="color:' + (full ? 'var(--brick-500)' : 'var(--text-secondary)') + '">' + st.swatches.length + ' of ' + swatchCount + '</span></div><div class="dh-swatchbox">' + furNames.map(function (n) {
          var on = st.swatches.indexOf(n) > -1, f = furOf(n);
          return '<button type="button" data-swatch="' + esc(n) + '" aria-pressed="' + on + '"' + (full && !on ? ' disabled' : '') + '><span class="dh-dot" style="background-color:' + f.color + ';background-image:url(' + esc(sized(f.image, 100)) + ')"></span><span>' + esc(n) + '</span></button>';
        }).join('') + '</div><p class="dh-micro" style="margin-top:var(--space-3)">Fur only — wood finishes are shown in the photography on each product page.</p></div>';
      }
      if (hasFinish) {
        var cur = get('finish');
        var cols = finishItems.length > 6 ? 4 : finishItems.length;
        html += '<div>' + label(MF.finishLabel || optNames[fi] || 'Finish', cur) + '<div class="dh-finishes" style="grid-template-columns:repeat(' + cols + ',minmax(0,1fr))">' + finishItems.map(function (f) {
          var w = woodOf(f.name);
          var o = {}; if (fi > -1) o[fi] = f.name;
          var off = fi > -1 && !findVariant(o);
          var bg = 'background-color:' + w.color + (w.image ? ';background-image:url(' + esc(sized(w.image, 200)) + ')' : '');
          return '<button type="button" class="dh-finish" data-finish="' + esc(f.name) + '" title="' + esc(f.name) + '" aria-pressed="' + (f.name === cur) + '"' + (off ? ' disabled' : '') + '><span class="dh-finish__chip" style="' + bg + '"></span><span class="dh-finish__name">' + esc(f.name) + '</span></button>';
        }).join('') + '</div></div>';
      }
      roles.forEach(function (r, i) { if (r === 'other' && !hasOnlyDefault) html += '<div>' + label(optNames[i], st.opts[i]) + sizeButtons(i) + '</div>'; });
      optsEl.innerHTML = html;

      if (swatchCount && st.swatches.length < swatchCount) { addBtn.disabled = true; addBtn.textContent = 'Choose ' + (swatchCount - st.swatches.length) + ' more'; }
      else if (!v || !v.available) { addBtn.disabled = true; addBtn.textContent = v ? 'Sold out' : 'Unavailable'; }
      else { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
      if (swatchFirstDot) {
        var sh = get('shade');
        swatchFirstDot.hidden = !sh;
        if (sh) { var ff = furOf(sh); swatchFirstDot.style.backgroundColor = ff.color; swatchFirstDot.style.backgroundImage = 'url(' + sized(ff.image, 100) + ')'; }
      }
      if (v && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
      renderPreview();
      renderBelow();
    }

    /* Shades with their own product page (dh.shade_pages) open that page */
    function pickShade(name) {
      var page = (MF.shadePages || {})[name];
      if (page && page.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) { window.location.href = page; return; }
      if (!setRole('shade', name)) return; renderAll();
    }
    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-opt]'))) {
        var i = +t.getAttribute('data-opt'); st.opts[i] = t.getAttribute('data-val');
        if (roles[i] === 'size') st.lastPick = 'size';
        renderAll();
      }
      else if ((t = e.target.closest('[data-size-pick]'))) { setRole('size', t.getAttribute('data-size-pick')); st.lastPick = 'size'; renderAll(); }
      else if ((t = e.target.closest('[data-height]'))) { st.height = t.getAttribute('data-height'); renderControls(); }
      else if ((t = e.target.closest('[data-shade]'))) pickShade(t.getAttribute('data-shade'));
      else if ((t = e.target.closest('[data-finish]'))) { setRole('finish', t.getAttribute('data-finish')); st.lastPick = 'finish'; renderAll(); }
      else if ((t = e.target.closest('[data-feature]'))) {
        setRole('shade', t.getAttribute('data-feature'));
        if (t.getAttribute('data-feature-size')) { setRole('size', t.getAttribute('data-feature-size')); st.lastPick = 'size'; }
        renderAll();
      }
      else if ((t = e.target.closest('[data-swatch]'))) {
        var n = t.getAttribute('data-swatch'), j = st.swatches.indexOf(n);
        if (j > -1) st.swatches.splice(j, 1); else if (st.swatches.length < swatchCount) st.swatches.push(n);
        renderControls(); return;
      } else return;
      if (t.closest('[data-dh-scrolltop]')) toTop();
    });

    var qtyInput = $('[data-dh-qty-main]', root);
    $$('[data-dh-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, Math.min(10, (Number(qtyInput.value) || 1) + Number(b.getAttribute('data-dh-step'))));
      });
    });
    addBtn.addEventListener('click', function () {
      var v = findVariant(); if (!v) return;
      var props = {};
      if (!shadeIsOption && st.shade && !swatchCount) props['Fur shade'] = st.shade;
      if (!finishIsOption && st.finish) props[frameNoun === 'frame' ? 'Frame' : 'Leg finish'] = st.finish;
      if (heightItems.length && st.height) props['Leg height'] = st.height;
      if (swatchCount) props['Swatches'] = st.swatches.join(', ');
      errEl.hidden = true; addBtn.disabled = true;
      DH.addToCart([{ id: v.id, quantity: Math.max(1, Number(qtyInput.value) || 1), properties: props }])
        .catch(function (err) { errEl.textContent = (err && (err.description || err.message)) || 'Could not add to cart.'; errEl.hidden = false; })
        .finally(function () { addBtn.disabled = false; });
    });

    /* Photography below the buy column — each block appears only when photographs are tagged for it */
    var below = $('[data-dh-below]', root);
    function img(url, alt, w, style) {
      return '<img src="' + esc(sized(url, w || 700)) + '" srcset="' + esc(sized(url, 400)) + ' 400w, ' + esc(sized(url, 700)) + ' 700w, ' + esc(sized(url, 1000)) + ' 1000w" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(alt) + '" loading="lazy"' + (style ? ' style="' + style + '"' : '') + '>';
    }
    function renderBelow() {
      if (!below) return;
      var html = '', name = P.title;
      var shadeTagged = tagged('shade');
      if (shadeTagged.length) {
        var list = MF.shadeGallery ? listItems(MF.shadeGallery).map(function (i) { return i.name; }) : [];
        if (!list.length) shadeTagged.forEach(function (m) { var v = tagOf(m, 'shade').value; if (list.indexOf(v) < 0) list.push(v); });
        html += '<section class="dh-sec" id="shades"><div class="dh-inner">' + sectionHead(T.shadeEyebrow, T.shadeTitle, T.swatchLink ? { label: 'Order a swatch box', url: T.swatchLink } : null) +
          '<div class="dh-pick-grid dh-pick-grid--auto" data-dh-scrolltop>' + list.map(function (s) {
            var t = tile('shade', s), f = furOf(s), on = s === get('shade');
            var media = t ? img(t.src, t.desc || name + ' in ' + s, 700, 'aspect-ratio:4/5') : img(f.image, s + ' Mongolian fur', 400, 'aspect-ratio:4/5');
            return '<button type="button" class="dh-pick" data-shade="' + esc(s) + '" aria-pressed="' + on + '"><span class="dh-pick__media">' + media +
              '<span class="dh-pick__dot" style="background-color:' + f.color + ';background-image:url(' + esc(sized(f.image, 100)) + ')"></span></span>' +
              '<span class="dh-pick__label"><span>' + esc(s) + '</span>' + (on ? '<span class="dh-pick__on">Selected</span>' : '') + (t ? '' : '<span class="dh-muted">Fur swatch</span>') + '</span></button>';
          }).join('') + '</div></div></section>';
      }
      if (tagged('finish').length && hasFinish) {
        var title = (T.finishTitle || '').replace('[count]', NUM_WORDS[finishItems.length] || finishItems.length);
        html += '<section class="dh-sec" id="finishes"><div class="dh-inner">' + sectionHead(T.finishEyebrow, title) +
          '<div class="dh-pick-grid dh-pick-grid--finish" data-dh-scrolltop>' + finishItems.map(function (f) {
            var t = tile('finish', f.name), w = woodOf(f.name), on = f.name === get('finish');
            var media = t ? img(t.src, t.desc || name + ', ' + f.name, 700, 'aspect-ratio:4/3') : (w.image ? img(w.image, f.name + ' wood finish', 400, 'aspect-ratio:4/3') : '<span class="dh-placeholder" style="aspect-ratio:4/3;background:' + w.color + '"></span>');
            return '<button type="button" class="dh-pick" data-finish="' + esc(f.name) + '" aria-pressed="' + on + '"><span class="dh-pick__media">' + media + '</span>' +
              '<span class="dh-pick__label">' + (w.image ? '<img src="' + esc(sized(w.image, 60)) + '" alt="">' : '') + '<span>' + esc(f.name) + '</span>' + (on ? '<span class="dh-pick__on">Selected</span>' : '') + '</span></button>';
          }).join('') + '</div></div></section>';
      }
      var lengthTagged = tagged('length');
      if (lengthTagged.length && idx('size') > -1) {
        var ratio = (lengthTagged.map(function (m) { return tagOf(m, 'length').ratio; }).filter(Boolean)[0]) || '3/2';
        html += '<section class="dh-sec"><div class="dh-inner">' + sectionHead(T.lengthEyebrow, T.lengthTitle) +
          '<div class="dh-grid dh-grid--4" data-dh-scrolltop>' + values[idx('size')].map(function (sz) {
            var m = tile('length', sz), t = m && tagOf(m, 'length'), v = findVariant({ size: sz }), on = sz === get('size');
            var media = m ? img(m.src, m.desc || name + ', ' + sz, 700, 'aspect-ratio:' + ratio + ';object-fit:' + (t.fit || 'cover') + ';object-position:' + (t.position || 'center'))
              : '<span class="dh-placeholder" style="aspect-ratio:' + ratio + ';border-style:solid;border-color:var(--border-hairline)"><span class="dh-d4" style="text-transform:none;letter-spacing:0;color:var(--ink-500)">' + esc(sizeDims[sz] || sz) + '</span></span>';
            return '<button type="button" class="dh-pick" data-size-pick="' + esc(sz) + '" aria-pressed="' + on + '"><span class="dh-pick__media">' + media + '</span>' +
              '<span class="dh-pick__label"><span>' + esc(sz) + '</span><span class="dh-muted">' + esc([sizeDims[sz], v ? money(v.price) : ''].filter(Boolean).join(' · ')) + '</span></span></button>';
          }).join('') + '</div></div></section>';
      }
      var scale = tagged('feature-scale'), styled = tagged('feature');
      if (MF.feature && (scale.length || styled.length)) {
        html += '<section class="dh-sec"><div class="dh-inner">' + sectionHead(MF.feature.eyebrow, MF.feature.title) +
          (scale.length ? '<div class="dh-grid dh-grid--4" data-dh-scrolltop>' + scale.map(function (m) {
            var t = tagOf(m, 'feature-scale');
            return '<button type="button" class="dh-pick" data-feature="' + esc(t.value) + '" data-feature-size="' + esc(t.size || '') + '" aria-pressed="' + (t.value === get('shade') && (!t.size || t.size === get('size'))) + '"><span class="dh-pick__media">' + img(m.src, m.desc || name + ', ' + t.value, 700, 'aspect-ratio:4/5') + '</span><span class="dh-pick__label"><span>' + esc(t.value) + '</span></span></button>';
          }).join('') + '</div>' : '') +
          (MF.feature.note ? '<p class="dh-caps dh-muted" style="margin-top:var(--space-4)">' + esc(MF.feature.note) + '</p>' : '') +
          (styled.length ? '<div class="dh-styled">' + styled.map(function (m, i) {
            var t = tagOf(m, 'feature');
            return img(m.src, m.desc || name + ' — styled ' + (i + 1), 700, 'aspect-ratio:' + (t.ratio || 'auto') + ';object-position:' + (t.position || 'center'));
          }).join('') + '</div>' : '') + '</div></section>';
      }
      if (MF.pairings && MF.pairings.length) {
        html += '<section class="dh-sec"><div class="dh-inner">' + sectionHead(T.pairEyebrow, T.pairTitle, T.pairLink ? { label: T.pairLinkLabel, url: T.pairLink } : null) +
          '<div class="dh-grid dh-grid--3">' + MF.pairings.map(function (pr) {
            var own = tile('pairing', pr.title), src = own ? own.src : pr.image;
            return '<div class="dh-pairing"><a href="' + esc(pr.url) + '">' + (src ? img(src, (own && own.desc) || pr.title + ' — ' + pr.note, 700) : '<span class="dh-placeholder" style="aspect-ratio:4/5">' + esc(pr.title) + '</span>') + '</a><div class="dh-pairing__row"><span class="dh-caps">' + esc(pr.title) + '</span><a class="dh-caps" href="' + esc(pr.url) + '">Shop</a></div><span class="dh-micro">' + esc(pr.note) + '</span></div>';
          }).join('') + '</div></div></section>';
      }
      below.innerHTML = html;
    }

    function renderAll() { renderControls(); renderGallery(); }
    renderAll();
  }

  /* ------------------------------------------------------------ Collection: type filter + sort */
  function initCollection(root) {
    var pills = $$('[data-dh-type]', root);
    var grid = $('[data-dh-grid]', root);
    if (!grid) return;
    var items = $$('.dh-grid__item', grid);
    var clear = $('[data-dh-clear]', root), empty = $('[data-dh-empty]', root), count = $('[data-dh-count]', root);
    var bar = $('[data-featured-count]', root);
    var featured = bar ? Number(bar.getAttribute('data-featured-count')) || 0 : 0;
    var on = [];
    pills.forEach(function (p) { if (p.getAttribute('aria-pressed') === 'true') on.push(p.getAttribute('data-dh-type')); });
    function apply() {
      var shown = 0;
      items.forEach(function (c) {
        var vis = !on.length || on.indexOf(c.getAttribute('data-type')) > -1;
        c.hidden = !vis; if (vis) shown++;
      });
      pills.forEach(function (p) { p.setAttribute('aria-pressed', on.indexOf(p.getAttribute('data-dh-type')) > -1 ? 'true' : 'false'); });
      if (clear) clear.hidden = !on.length;
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = shown + featured;
    }
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var t = p.getAttribute('data-dh-type'), i = on.indexOf(t);
        if (i > -1) on.splice(i, 1); else on.push(t);
        apply();
      });
    });
    if (clear) clear.addEventListener('click', function () { on = []; apply(); });
    var sort = $('[data-dh-sort]', root);
    if (sort) sort.addEventListener('change', function () {
      var key = sort.value;
      var n = function (el, a) { return Number(el.getAttribute(a)) || 0; };
      items.slice().sort(function (a, b) {
        if (key === 'price-asc') return n(a, 'data-price') - n(b, 'data-price');
        if (key === 'price-desc') return n(b, 'data-price') - n(a, 'data-price');
        if (key === 'newest') return n(b, 'data-created') - n(a, 'data-created');
        return n(a, 'data-index') - n(b, 'data-index');
      }).forEach(function (el) { grid.appendChild(el); });
    });
    apply();
  }

  /* Seating: The Chair feature, one shade large */
  function initChairFeature(root) {
    var dots = $$('[data-dh-chair-dot]', root);
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var id = d.getAttribute('data-dh-chair-dot');
        dots.forEach(function (x) { x.setAttribute('aria-pressed', x === d ? 'true' : 'false'); });
        $$('[data-chair]', root).forEach(function (el) { el.hidden = el.getAttribute('data-chair') !== id; });
      });
    });
  }

  /* ------------------------------------------------------------ Gallery: room filter */
  function initRooms(root) {
    var pills = $$('[data-dh-room]', root), posts = $$('[data-room]', root), count = $('[data-dh-room-count]', root), title = $('[data-dh-room-title]', root);
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var r = p.getAttribute('data-dh-room');
        pills.forEach(function (x) { x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
        var n = 0;
        posts.forEach(function (el) { var vis = r === 'all' || el.getAttribute('data-room') === r; el.hidden = !vis; if (vis) n++; });
        if (count) count.textContent = n + (n === 1 ? ' story' : ' stories');
        if (title) title.textContent = r === 'all' ? title.getAttribute('data-all') : p.textContent;
      });
    });
  }

  /* ------------------------------------------------------------ Trade request: three routes, one form */
  function initTrade(root) {
    var form = $('[data-dh-trade-form]', root);
    var kind = $('[name="contact[Request]"]', root);
    var submit = $('[data-dh-trade-submit]', root);
    var labels = { trade: 'Trade account application', bulk: 'Large order enquiry (10+)', commission: 'Re-fur or commission — quote request' };
    function setMode(m) {
      if (!form) return;
      form.hidden = false;
      $$('[data-dh-mode-btn]', root).forEach(function (b) { b.classList.toggle('dh-btn--primary', b.getAttribute('data-dh-mode-btn') === m); b.classList.toggle('dh-btn--outline', b.getAttribute('data-dh-mode-btn') !== m); });
      $$('[data-dh-tab]', root).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-dh-tab') === m ? 'true' : 'false'); });
      $$('[data-mode]', root).forEach(function (el) {
        var vis = el.getAttribute('data-mode').split(' ').indexOf(m) > -1;
        el.hidden = !vis;
        $$('input,select,textarea', el).forEach(function (i) { i.disabled = !vis; });
      });
      if (kind) kind.value = labels[m];
      if (submit) submit.textContent = m === 'trade' ? 'Send application' : 'Request a quote';
    }
    $$('[data-dh-mode-btn],[data-dh-tab]', root).forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-dh-mode-btn') || b.getAttribute('data-dh-tab')); });
    });
    if (form && !form.hidden) setMode(form.getAttribute('data-initial') || 'trade');
  }

  /* ------------------------------------------------------------ Home: shop by shade */
  function initShadeBand(root) {
    var name = $('[data-dh-shade-name]', root), link = $('[data-dh-shade-link]', root);
    $$('[data-dh-band-shade]', root).forEach(function (b, _, all) {
      b.addEventListener('click', function () {
        all.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var s = b.getAttribute('data-dh-band-shade');
        if (name) name.textContent = s;
        if (link) { link.textContent = 'Shop ' + s; link.href = link.getAttribute('data-base') + (link.getAttribute('data-base').indexOf('?') > -1 ? '&' : '?') + 'shade=' + encodeURIComponent(s); }
      });
    });
  }

  function init() {
    initAnnounce();
    initHeader();
    initCart();
    $$('[data-dh-product]').forEach(initProduct);
    $$('[data-dh-collection]').forEach(initCollection);
    $$('[data-dh-chair-feature]').forEach(initChairFeature);
    $$('[data-dh-rooms]').forEach(initRooms);
    $$('[data-dh-trade]').forEach(initTrade);
    $$('[data-dh-shade-band]').forEach(initShadeBand);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target;
    $$('[data-dh-product]', r).forEach(initProduct);
    $$('[data-dh-collection]', r).forEach(initCollection);
    $$('[data-dh-chair-feature]', r).forEach(initChairFeature);
    $$('[data-dh-rooms]', r).forEach(initRooms);
    $$('[data-dh-trade]', r).forEach(initTrade);
    $$('[data-dh-shade-band]', r).forEach(initShadeBand);
  });
})();
